import { BrowserRouter as Router } from 'react-router-dom';
import { StackNavigator } from './navigation/StackNavigator';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getOrCreateDeviceUUID } from './utils/deviceId';
import { useAppDispatch } from './store';
import { setDeviceUUID } from './store/slices/deviceIdSlice';
import { useEffect } from 'react';
import InstallPWA from './components/InstallPWA';

function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    getOrCreateDeviceUUID().then((uuid) => {
      dispatch(setDeviceUUID(uuid));
    });
  }, []);

  return (
    <div className='container' style={{ height: '100vh' }}>
      <Router>
        <StackNavigator />
      </Router>
      <ToastContainer position='top-center' />
      <InstallPWA />
    </div>
  );
}

export default App;
